/**
 * Hook de **alta de orden** (`POST /api/v1/orders`).
 *
 * Envuelve `createOrder` en un `useMutation`. Tras éxito **invalida los listados**
 * (`docs/frontend_conventions.md`, Datos): la orden nueva debe aparecer en la lista
 * de pendientes, así que se invalida la raíz `['orders']`. El gating de permiso
 * (`add_orders`) lo decide la UI antes de exponer la pantalla; aquí solo se ejecuta
 * y se propaga el `ApiError` (la pantalla traduce `{error_code, message}`).
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createOrder } from "../api";
import type { OrderDetail, OrderWriteBody } from "../types";
import { ORDERS_ROOT_KEY } from "./queryKeys";

export function useCreateOrder() {
  const queryClient = useQueryClient();

  return useMutation<OrderDetail, Error, OrderWriteBody>({
    mutationFn: (body) => createOrder(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ORDERS_ROOT_KEY });
    },
  });
}
